import { render } from "./TaxReportCustom2025.vue?vue&type=template&id=78f70715&scoped=true"
import script from "./TaxReportCustom2025.vue?vue&type=script&lang=js"
export * from "./TaxReportCustom2025.vue?vue&type=script&lang=js"

import "./TaxReportCustom2025.vue?vue&type=style&index=0&id=78f70715&scoped=true&lang=css"
import "./TaxReportCustom2025.vue?vue&type=style&index=1&id=78f70715&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f70715"]])

export default __exports__